import {
  CategoryAutoEnum,
  FuelTypeEnum,
  TimezoneCode,
  TransmissionEnum,
} from '~/shared/config/enums'
import { myPalette } from '~/shared/lib/theme'

export const AUTH_TOKEN_STORAGE_KEY = 'auth_token'
export const AUTH_EMAIL_STORAGE_KEY = 'auth_email'
export const AUTH_CURRENT_USER_ID_STORAGE_KEY = 'auth_current_user_id'
export const USER_PERMISSIONS_STORAGE_KEY = 'user_permissions'

export const MIN_COLUMN_WIDTH = 90

export type Option = { id: string | number; label: string | number }
export type OptionEnum<T> = { id: T; label: string }

export const timezoneCodeLabels: Record<TimezoneCode, string> = {
  [TimezoneCode.KALININGRAD]: 'Калининград (UTC+2)',
  [TimezoneCode.MOSCOW]: 'Москва (UTC+3)',
  [TimezoneCode.SAMARA]: 'Самара (UTC+4)',
  [TimezoneCode.YEKATERINBURG]: 'Екатеринбург (UTC+5)',
  [TimezoneCode.OMSK]: 'Омск (UTC+6)',
  [TimezoneCode.KRASNOYARSK]: 'Красноярск (UTC+7)',
  [TimezoneCode.IRKUTSK]: 'Иркутск (UTC+8)',
  [TimezoneCode.YAKUTSK]: 'Якутск (UTC+9)',
  [TimezoneCode.VLADIVOSTOK]: 'Владивосток (UTC+10)',
  [TimezoneCode.MAGADAN]: 'Магадан (UTC+11)',
  [TimezoneCode.KAMCHATKA]: 'Камчатка (UTC+12)',
}

export const timezoneCodeOptions: OptionEnum<TimezoneCode>[] = Object.values(
  TimezoneCode,
).map((value) => ({
  label: timezoneCodeLabels[value as TimezoneCode],
  id: value as TimezoneCode,
}))

export const STATUS_VARIANT = {
  green: {
    backgroundColor: myPalette.green['100'],
    color: myPalette.green['600'],
  },
  red: {
    backgroundColor: myPalette.red['100'],
    color: myPalette.red['600'],
  },
  gray: {
    backgroundColor: myPalette.gray['100'],
    color: myPalette.gray['700'],
  },
  yellow: {
    backgroundColor: myPalette.yellow['100'],
    color: myPalette.yellow['600'],
  },
}

export const fuelTypeLabels: Record<FuelTypeEnum, string> = {
  [FuelTypeEnum.AI100]: 'АИ-100',
  [FuelTypeEnum.AI92]: 'АИ-92',
  [FuelTypeEnum.AI95]: 'АИ-95',
  [FuelTypeEnum.AI98]: 'АИ-98',
  [FuelTypeEnum.DIESEL]: 'Дизельное',
  [FuelTypeEnum.METHANE]: 'Метан',
  [FuelTypeEnum.PROPANE]: 'Пропан',
  [FuelTypeEnum.ELECTRICITY]: 'Электрический',
}

export const fuelTypeOptions: OptionEnum<FuelTypeEnum>[] = Object.values(
  FuelTypeEnum,
).map((value) => ({
  label: fuelTypeLabels[value as FuelTypeEnum],
  id: value as FuelTypeEnum,
}))

export const categoryAutoLabels: Record<CategoryAutoEnum, string> = {
  [CategoryAutoEnum.ECONOMY]: 'Эконом',
  [CategoryAutoEnum.COMFORT]: 'Комфорт',
  [CategoryAutoEnum.COMFORT_PLUS]: 'Комфорт+',
  [CategoryAutoEnum.BUSINESS]: 'Бизнес',
  [CategoryAutoEnum.COMFORT_LOWER_CASE]: 'комфорт',
  [CategoryAutoEnum.ECONOMY_LOWER_CASE]: 'эконом',
  [CategoryAutoEnum.COMFORT_PLUS_LOWER_CASE]: 'комфорт +',
  [CategoryAutoEnum.COMFORT_PLUS_SECOND]: 'Комфорт +',
}

export const categoryAutoLabelToEnum: Record<string, CategoryAutoEnum> = {
  Эконом: CategoryAutoEnum.ECONOMY,
  Комфорт: CategoryAutoEnum.COMFORT,
  'Комфорт+': CategoryAutoEnum.COMFORT_PLUS,
  Бизнес: CategoryAutoEnum.BUSINESS,
  комфорт: CategoryAutoEnum.COMFORT_LOWER_CASE,
  эконом: CategoryAutoEnum.ECONOMY_LOWER_CASE,
  'комфорт +': CategoryAutoEnum.COMFORT_PLUS_LOWER_CASE,
  'Комфорт +': CategoryAutoEnum.COMFORT_PLUS_SECOND,
}

export const categoryAutoOptions: OptionEnum<CategoryAutoEnum>[] =
  Object.values(CategoryAutoEnum).map((value) => ({
    label: categoryAutoLabels[value as CategoryAutoEnum],
    id: value as CategoryAutoEnum,
  }))

export const transmissionLabels: Record<TransmissionEnum, string> = {
  [TransmissionEnum.AUTO]: 'Автоматическая',
  [TransmissionEnum.MANUAL]: 'Механическая',
}

export const transmissionOptions: OptionEnum<TransmissionEnum>[] =
  Object.values(TransmissionEnum).map((value) => ({
    label: transmissionLabels[value as TransmissionEnum],
    id: value as TransmissionEnum,
  }))
